<template>
  <div id="home-parent" class="page-container">
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image parallax-img"
        style="background-image: url('img/background_0.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Podologiepraxis Boldt.</h1>
          <div class="text-center">
            <h3>Gesunde Füße - mehr Lebensqualität</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h2 class="title">Willkommen</h2>
            <h4 class="description">
              Unsere Füße tragen uns durchs Leben - Tag für Tag. Deshalb verdienen sie die bestmögliche medizinische Betreuung. 
              Als <strong>staatlich geprüfte Podologin mit Kassenzulassung</strong> bieten mein Team und ich Ihnen Behandlungen für gesetzlich und privat Versicherte, sowie Selbstzahler an.
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Fußgesundheit erhalten und verbessern<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Beschwerden wirksam behandeln<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Ihre Mobilität und Lebensqualität sichern
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div
              class="image-container image-left"
              style="background-image: url('img/landing_img_1.jpg')"
            >
            </div>
          </div>
          <div class="col-md-5">
            <!-- First image on the right side, above the article -->
            <div
              class="image-container image-right"
              style="background-image: url('img/landing_img_2.jpg')"
            ></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="description">
              Vereinbaren Sie jetzt einen Termin - wir freuen uns auf Sie!<br>
              <n-button type="primary" round @click="openPhone()">
                <span class="mdi mdi-phone-classic"></span> 06412 / 747259275
              </n-button>
              <br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@podologie-boldt.de
              </n-button>
            </h4>
          </div>
        </div>
        <div class="separator separator-primary"></div>
      </div>
    </div>
    <div class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: !secondForeground}">
          <picture class="background-img">
            <source srcset="img/background_1_wide.jpg" media="(min-width: 600px)" />
            <img src="img/background_1.jpeg" />
          </picture>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Über uns</h2>
            <h4 class="description">
              Wir sind Natalja Boldt, staatlich geprüfte Podologin mit 10 Jahren Berufserfahrung im fusspflegerischen Bereich
              und Andreas Maranditsch, angehender Podologe.
              Unser Ziel ist es, Ihre Füße gesund zu halten und Beschwerden zu lindern.
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Individuelle und einfühlsame Betreuung<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Hohe Hygienestandards<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Zusammenarbeit mit Ärzten bei medizinischer Notwendigkeit
            </h4>
            <h4 class="description">
              Unser hoher Hygienestandard ist durch die Eintragung ins <a class="link" target="_blank" href="https://deutsches-hygiene-register.de/eintraege/natalja-boldt-podologie-fachpraxis-fusspflege-kosmetik-manikuere/">Deutsche Hygieneregister</a> umfassend geprüft und mit sehr gut bewertet.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Unsere Leistungen</h2>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Behandlung von eingewachsenen oder verdickten Nägeln<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Entfernung von Hühneraugen, Schwielen und Druckstellen<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Podologische Komplexbehandlung (z. B. Diabetes, Gefäßerkrankungen)<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Nagelkorrekturspangen<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Orthosen (Druck- und Reibungsschutz)<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Prävention & Beratung zur Fußgesundheit
            </h4>
          </div>
        </div>
        <div class="row justify-content-center mt-5">
          <div class="col-12 carousel-container">
            <el-carousel :height="carouselHeight" autoplay>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_3.jpg" alt="First slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_4.jpg" alt="Second slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_5.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_6.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_7.jpg" alt="Third slide" />
              </el-carousel-item>
              <el-carousel-item>
                <img class="d-block" src="img/landing_img_8.jpg" alt="Third slide" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div id="background-observer" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Für gesetzlich Versicherte</h2>
            <h4 class="description">
              Mit einer ärztlichen Verordnung können Sie podologische Behandlungen direkt über Ihre gesetzliche Krankenversicherung abrechnen. Typische Indikationen:
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Diabetes mellitus mit Folgeschäden<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Neuropathien<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Durchblutungsstörungen
            </h4>
            <h4 class="description">
              <span class="mdi mdi-lightbulb-on-outline" style="color: yellow"></span> 
              <i style="color: yellow"> Gut zu wissen:</i> Podologische Behandlungen mit Privatrezept können von vielen Privatversicherungen übernommen werden. Sie erhalten eine Rechnung zur Einreichung bei Ihrer Versicherung.
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div id="second-background" class="section section-about-us background-img-wrapper">
      <div class="container">
        <div class="background-container" :class="{foreground: secondForeground}">
          <picture class="background-img">
            <source srcset="img/background_2_wide.jpg" media="(min-width: 600px)" />
            <img src="img/background_2.jpeg" />
          </picture>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Von der Fußpflege zur Podologie</h2>
            <h4 class="description">
              Fußpflege sorgt für gepflegte Füße, aber Podologie geht weiter:
            </h4>
            <h4 class="description list">
              <span class="mdi mdi-arrow-right-bold-outline"></span> Medizinischer Fachberuf mit klar definierten Standards<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Behandlung krankhafter Veränderungen am Fuß<br>
              <span class="mdi mdi-arrow-right-bold-outline"></span> Enge Zusammenarbeit mit Ärzten
            </h4>
            <h4 class="description">
              <strong>Schöne Füße macht die Fußpflege - gesunde Füße die Podologie.</strong>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Kontakt</h2>
        <div class="row">
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <span class="mdi mdi-map-marker-outline"></span> Unsere Adresse:<br>
              Hufelandstraße 14,<br>
              34537 Bad WIldungen
            </h4>
          </div>
          <div class="col-lg-6 ml-auto mr-auto text-center">
            <h4 class="description">
              <iframe src="https://maps.google.com/maps?q=Natalja+Boldt+Podologie+Fachpraxis.+Fußpflege,+Kosmetik,+Maniküre+-+Bad+Wildungen&z=16&output=embed"
                allowfullscreen="allowfullscreen" 
                frameborder="0"
                :width="mapWidth"
                :height="mapHeight"
                data-gtm-yt-inspected-11="true" 
                style="border: 0px;">
              </iframe>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 ml-auto mr-auto text-center">
            <h4 class="description">
              Rufen Sie uns an:<br>
              
              <n-button type="primary" class="phone-btn" round @click="openPhone()">
                <span class="mdi mdi-phone-classic"></span> 05621 / 96 78 78 6
              </n-button><br>
              <span class="opening-time">(Mo-Do 9:00 - 18:00)</span><br>
            </h4>
            <h4 class="description small-margin-bottom">
              Oder schreiben Sie uns eine E-Mail<br>
              <n-button type="primary" round @click="openEmail()">
                <span class="mdi mdi-email-outline"></span> kontakt@podologie-boldt.de
              </n-button>
            </h4>
            <h4 class="description">
              <span class="mdi mdi-heart-outline"></span><strong> Wir freuen uns auf Sie! </strong><span class="mdi mdi-heart-outline"></span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import { Carousel, CarouselItem } from 'element-ui';
import Parallax from 'vue-parallaxy'
export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  created() {
    //window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    //window.removeEventListener("resize", this.myEventHandler);
  },
  mounted() {
    const options = {
      rootMargin: "0px",
      scrollMargin: "0px",
      threshold: [0, 0.25, 0.5, 0.75, 1.00],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(this.intersectionY > entry.boundingClientRect.y && entry.intersectionRatio >= 0.5) {
          this.secondForeground = true;
        } else if(this.previousRatio > entry.intersectionRatio
            && this.intersectionY < entry.boundingClientRect.y 
            && entry.intersectionRatio <= 0.5) {
          this.secondForeground = false;
        }
        this.intersectionY = entry.boundingClientRect.y
        this.previousRatio = entry.intersectionRatio
      });
    }, options);

    const target = document.querySelector("#background-observer");
    observer.observe(target);

    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize); 
  },
  data() {
    return {
      secondForeground: false,
      intersectionY: 0,
      previousRatio: 0,
      mapWidth: "600px",
      mapHeight: "400px",
      carouselHeight: "300px",
    };
  },
  methods: {
    onResize() {
      let mapWidth = window.innerWidth - 10
      mapWidth = Math.min(mapWidth, 600)

      const mapHeight = mapWidth / 1.5

      this.mapWidth = mapWidth + 'px'
      this.mapHeight = mapHeight + 'px'

      const carouselContaner = document.getElementsByClassName("carousel-container")[0];
      let carouselWidth = carouselContaner.clientWidth
      carouselWidth = Math.min(carouselWidth, 800)
      this.carouselHeight = (carouselWidth / 2.2) + 'px'
    },
    openPhone: function() {
      window.location = "tel:+4956219678786";
    },
    openWhatsapp: function() {
      window.open("https://wa.me/4917655980480", "_blank");
    },
    openEmail: function() {
      window.location = "mailto:kontakt@podologie-boldt.de";
    }
  }
};
</script>
<style scoped>
.background-img-wrapper {
  background-color: #00000060 !important;

  .title {
    color: white !important;
  }
  .description {
    color: white !important;
    font-weight: normal !important;
  }
  .background-container {
    left: 0;
    bottom: 0;
    position: fixed;
    z-index: -2;
    width: 100vw;
    height: 100vh;

    .background-img {
      * {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
.parallax-img {
  z-index: 0 !important;
}
.foreground {
  z-index: -1 !important;
}
.parallax-test {
  position: relative;
}
.list {
  text-align: left;
  margin-left: 100px;
}
.small-margin-bottom {
  margin-bottom: 5px;
}
.phone-btn {
  margin-bottom: 0 !important;
}
.opening-time {
  font-size: small;
}
.link {
  color: white !important;
  text-decoration: underline;
}
iframe {
  width: 100%;
  height: auto;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 4/3;
}
.video {
  width: auto;
  height: 90vh;
  max-width: 100%; /* or whatever you want it to be */
  aspect-ratio: 9/16;
}
.title-logo {
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  width: 80%;
  height: auto;
}

.carousel-container {
  max-width: 800px !important;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
